import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { HttpService } from "../http/http.service";

@Injectable()
export class PlataformasService extends ApiService {
    constructor(protected http: HttpService) {
        super(http);
        this.url = 'api/plataformas/'
    }
}



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/lspcourier-dev/src/app/shared/services/api/plataformas.service.ts